<template>
    <div class="control has-icons-right">
        <input :type="passwordVisible ? 'text' : 'password'" class="input" :value="value" v-on:input="$emit('input', $event.target.value)">
        <span @click="togglePasswordVisible()" class="icon is-right is-small toggle-password has-text-dark"><i class="fas" :class="!passwordVisible ? 'fa-eye' : 'fa-eye-slash'" :data-icon="passwordVisible ? 'fa-eye' : 'fa-eye-slash'"></i></span>
    </div>
</template>

<style>
.icon.toggle-password {
    pointer-events: auto!important;
    cursor: pointer!important;
}
</style>


<script>
export default {
    name: "PasswordField",
    props: ["value"],
    data() {
        return {
            passwordVisible: false
        }
    },
    methods: {
        togglePasswordVisible() {
            this.passwordVisible = !this.passwordVisible;
        }
    }
}
</script>